export const HAS_PROPOSAL_COLOR = "var(--token-surface-success-200)";
export const NO_PROPOSAL_COLOR = "var(--token-surface-gray-200)";
export const HAS_PROPOSAL_LABEL = "Has proposal";
export const NO_PROPOSAL_LABEL = "Has no proposals";
